export interface IAccount {
	homePage?: string;
	name?: string;
}

export function isAccount(item: any): item is IAccount {
	return item.homePage || item.name;
}
